var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafariPinnedTab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "70.000000pt",
    height: "70.000000pt",
    viewBox: "0 0 70.000000 70.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.14, written by Peter Selinger 2001-2017\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,70.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190 641 c-5 -11 -10 -31 -10 -45 0 -24 4 -26 40 -26 36 0 40 3 48 33 6 20 5 37 -1 45 -15 19 -65 15 -77 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466 634 c-3 -9 -6 -27 -6 -40 0 -21 4 -24 39 -24 40 0 50 13 51 63 0 23 -75 25 -84 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 348 c-15 -90 -27 -173 -27 -186 0 -36 28 -81 63 -102 47 -29 149 -27 199 3 40 25 72 60 82 92 5 17 66 341 66 352 0 2 -17 3 -38 3 l-39 0 -18 -102 c-45 -255 -51 -270 -114 -289 -50 -15 -86 -6 -107 27 -16 23 -15 34 10 187 14 89 26 165 26 170 0 4 -17 7 -38 7 l-38 0 -27 -162z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafariPinnedTab);
export default __webpack_public_path__ + "static/media/safari-pinned-tab.17b1f94c21cd4611e00ab8902468bb29.svg";
export { ForwardRef as ReactComponent };